/* eslint-disable eqeqeq */
/* eslint-disable spaced-comment */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useContext, useState } from "react";
import Sectors from "../../SectorType/SectorIndex";
import { isMobile } from "react-device-detect";
import { UmbracoContext, UmbracoStep } from "components/Umbraco/UmbracoContext";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import MySpinner from "../../../components/Spinner";
import PopUpBitcoin from "./PopUpBitcoin";

import utils from "utils";
import { Center, IconTiny, LabelBig, LabelCenter, Row } from "meitav-uikit";

const { UmbracoUtills, rest } = utils;

export default function Section6(props) {
  const { lobbyDetailsData } = props;
  const [selectedItem, setSelectedItem] = useState("");
  const [lobbyDetailsBySector, setLobbyDetailsBySector] = useState([]);
  const [openChange, setOpenChange] = useState(true);
  const [openSpinner, setOpenSpinner] = useState(false);
  const [open, setOpen] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const resource = UmbracoStep(useContext(UmbracoContext).resource, "Section6");
  const resourcePopUp = UmbracoStep(
    useContext(UmbracoContext).resource,
    "PopUpBitcoin"
  );
  useEffect(() => {
    getLobbyDetails();
  }, []);

  const investPolicyGUID = localStorage.getItem("investPolicyGUID");

  const getLobbyDetails = async () => {
    let tmp = [];

    for (var i = 1; i <= lobbyDetailsData.sectorCount; i++) {
      if (lobbyDetailsData.sectorCode != i) {
        const ans = await getLobbyDetailsBySector(i);
        tmp.push(ans);
      } else {
        tmp.push(lobbyDetailsData);
      }
    }
    setLobbyDetailsBySector(tmp);
  };

  const getLobbyDetailsBySector = async (sectorCode) => {
    const formData = {};
    formData.guid = localStorage.getItem("investPolicyGUID");
    formData.sectorCode = sectorCode;
    const result = await rest.post("/api/Manager/GetLobbyDetails", {
      data: formData,
    });
    if (result.data.calculetedHerkevTik) {
      result.data.calculetedHerkevTik.sort((a, b) =>
        a.totalAfikPercent < b.totalAfikPercent ? 1 : -1
      );
    }
    return result.data;
  };
  const openChangeClick = () => {
    setOpenChange(!openChange);
  };
  const changeProfile = async () => {
    window.dataLayer.push({
      event: "PM - ivestment",
      eventInfo: {
        action_screen: window.location.pathname,
        process_level: "הרכב תיק ההשקעות",
        action_name: "אישור שינוי הרכב התיק",
      },
    });

    const result = await rest.get(
      `/api/Manager/ChangeUserPorfile?guid=${investPolicyGUID}`
    );
    window.open(`/CustomerInvestPolicy`, "_self");
  };

  const sectorChange = async (obj) => {
    if (obj.code == 6 && lobbyDetailsData.riskLevel < 5) {
      props.lobbyDetailsData.sectorCode = obj.code;
      setOpen(true);
    } else {
      const action_name8 = `אפיק ההשקעות שבחרתי- ${obj.name}`;
      window.dataLayer.push({
        event: "PM - sector",
        eventInfo: {
          action_screen: window.location.pathname,
          sectorCode: obj.code,
          process_level: "בחירת אפיק השקעה",
          action_name: action_name8,
        },
      });
      //if (lobbyDetailsData.sectorCode != obj.code) {
      props.lobbyDetailsData.sectorCode = obj.code;
      await saveSectorType(obj.code);
      if (lobbyDetailsBySector.length > 0)
        props.setLobbyDetailsData(lobbyDetailsBySector[obj.code - 1]);
      //}
      setOpenChange(false);
    }
  };

  const handleReCaptchaVerify = async (actionName) => {
    if (!executeRecaptcha) {
      return false;
    }
    const token = await executeRecaptcha(actionName);
    return token;
    // Do whatever you want with the token
  };

  const saveSectorType = async (selectedCode) => {
    const data = {
      joinInvestPolicyTempGuid: investPolicyGUID,
      sectorCode: selectedCode,
    };

    setOpenSpinner(true);

    const SaveSectorTypetoken = await handleReCaptchaVerify(
      `SaveSectorTypetoken`
    );

    const data1 = JSON.stringify(data);

    const ans = await rest.get(`/api/Manager/SaveSectorType?data=${data1}`, {
      headers: {
        gCaptcha: SaveSectorTypetoken,
        action: "SaveSectorType",
      },
    });
    setOpenSpinner(false);
  };

  return (
    <div className="section6 mb-5">
      <div className="wrapper">
        <Row type="small" className={`${isMobile ? "containerMobile" : ""}`}>
          {selectedItem.code && (
            <>
              <Row className="title large">
                <IconTiny
                  src={`${
                    import.meta.env.VITE_REACT_APP_IMAGE_URL ||
                    window.location.origin
                  }${selectedItem.icon}`}
                />
                <LabelCenter className="h1Accibility">
                  {`${UmbracoUtills.getParsedHtmlValueByKey(
                    resource,
                    "title"
                  )} ${selectedItem.name}`}
                </LabelCenter>
              </Row>
              <div
                className="text"
                role="button"
                aria-label="שנה אפיק השקעה"
                tabIndex={2}
                onKeyPress={() => openChangeClick()}
                onClick={() => openChangeClick()}
              >
                {UmbracoUtills.getParsedHtmlValueByKey(resource, "changeText")}
                <img className={openChange ? "arrow-up" : "arrow-down"} />
              </div>
            </>
          )}
          {openChange ? (
            <div className="col-xs-12 text-center mt-4">
              <div
                className={
                  selectedItem.code
                    ? "sectorItemList cube"
                    : "sectorItemListHide"
                }
              >
                <Sectors
                  anserOld={lobbyDetailsData.sectorCode}
                  sectorOnChange={sectorChange}
                  selectedItem={selectedItem}
                  setSelectedItem={setSelectedItem}
                  mode={"cube"}
                  riskLevel={lobbyDetailsData.riskLevel}
                />
              </div>
            </div>
          ) : null}
        </Row>
      </div>
      {openSpinner && <MySpinner />}
      <PopUpBitcoin
        openProp={open}
        setOpen={setOpen}
        okBtnClick={changeProfile}
        icon={"restartIcon"}
        resourceText={UmbracoUtills.getValueByKey(resourcePopUp, "text")}
        changeProfileBtn={UmbracoUtills.getValueByKey(
          resourcePopUp,
          "changeProfile"
        )}
        changeAfikBtn={UmbracoUtills.getValueByKey(resourcePopUp, "changeAfik")}
      />
    </div>
  );
}
